import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form'; // Importa o Form do react-bootstrap
import styled from 'styled-components';

interface TagOption {
  id: number;
  tag: string;
}

interface CheckBoxListProps {
  opcoes: TagOption[];
  onChange?: (selectedTags: number[]) => void; // Para permitir que você manipule os checkboxes selecionados
  opcoesSelecionadas?: number[]; // Nova prop para as opções pré-selecionadas
  isOpen: boolean; // Nova prop que indica se o modal está aberto
}

const ContainerCheckBoxList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Três colunas */
  gap: 10px; /* Espaçamento entre os itens */
  padding: 20px;
  font-size: 1rem;
`;

const CheckBoxWrapper = styled.div`
  display: flex;
  align-items: center;

  input[type='checkbox'] {
    transform: scale(1.15); /* Aumenta o tamanho da checkbox */
    align-items: center;
  }
`;

const CheckBoxList: React.FC<CheckBoxListProps> = ({
  opcoes,
  onChange,
  opcoesSelecionadas = [],
  isOpen,
}) => {
  const [selectedTags, setSelectedTags] = useState<number[]>([]);

  // Sincroniza o estado com as opções selecionadas ao abrir o modal
  useEffect(() => {
    if (isOpen) {
      // Se não houver tags selecionadas, marca "Nenhuma tag"
      if (opcoesSelecionadas.length === 0) {
        setSelectedTags([9999]);
      } else {
        setSelectedTags(opcoesSelecionadas);
      }
    }
  }, [isOpen, opcoesSelecionadas]);

  const handleCheckboxChange = (id: number) => {
    let updatedTags: number[];

    if (id === 9999) {
      updatedTags = [9999]; // Seleciona apenas "Nenhuma tag"
    } else {
      updatedTags = selectedTags.includes(id)
        ? selectedTags.filter((tagId) => tagId !== id) // Remove tag
        : [...selectedTags.filter((tagId) => tagId !== 9999), id]; // Adiciona tag
    }

    setSelectedTags(updatedTags);
    if (onChange) onChange(updatedTags); // Chama o callback
  };

  // Reorganizar as opções para preencher verticalmente
  const reorganizeOptions = (opcoes: TagOption[]): TagOption[] => {
    const colCount = 3; // Número de colunas
    const itemsPerColumn = Math.ceil(opcoes.length / colCount); // Itens por coluna
    const reordered: TagOption[] = [];

    // Preenche as colunas verticalmente
    for (let i = 0; i < itemsPerColumn; i++) {
      for (let j = 0; j < colCount; j++) {
        const index = i + j * itemsPerColumn;
        if (opcoes[index]) {
          reordered.push(opcoes[index]);
        }
      }
    }

    return reordered;
  };

  // Adiciona o item "Nenhuma Tag" no início e reorganiza as opções
  const opcoesComNenhumaTag = [...opcoes];
  const opcoesReorganizadas = reorganizeOptions(opcoesComNenhumaTag);

  return (
    <ContainerCheckBoxList>
      {opcoesReorganizadas.map((tag) => (
        <CheckBoxWrapper key={tag.id}>
          <Form.Check
            type="checkbox"
            id={`checkbox-${tag.id}`}
            label={tag.tag}
            checked={selectedTags.includes(tag.id)}
            onChange={() => handleCheckboxChange(tag.id)}
          />
        </CheckBoxWrapper>
      ))}
    </ContainerCheckBoxList>
  );
};

export default CheckBoxList;
